import { Injectable } from '@angular/core';
import {HttpInterceptor2} from "./HttpInterceptor.service";
import {GlobalVariable} from "./global.vars";

@Injectable()
export class UtilsService {
  private BND_URL = GlobalVariable.BND_URL;
  private Http: HttpInterceptor2;

  constructor (public httpInterceptor: HttpInterceptor2) {
    this.Http = httpInterceptor;
  }

  getAddress(coordinateList){
    let coordinates = "";
    for(let elem of coordinateList) {
      if (coordinates)
        coordinates += "&xy=" + elem[0] + "," + elem[1];
      else
        coordinates = "&xy=" + elem[0] + "," + elem[1]
    }

    return this.Http.post(this.BND_URL+'?geoserver=default&version=1.0.0&action=revgeoBatch&radius=500&language=fr&options=polyline&format=json', coordinates)
  }

  format(address){
  let addr="";
  if(address && address.PostalAddress){
    if(address.PostalAddress.StreetNumber){
      addr+= address.PostalAddress.StreetNumber;
    }
    if(address.PostalAddress.Street){
      addr+= " " +address.PostalAddress.Street;

    }
    if(address.PostalAddress.District){
      addr+=" " +address.PostalAddress.District;
    }
    if(address.PostalAddress.City){
      addr+=" " +address.PostalAddress.City;
    }
    if(address.PostalAddress.Country){
      addr+=", " +address.PostalAddress.Country;
    }
  }
  return  addr;
}
}



// WEBPACK FOOTER //
// ./src/services/utils.service.ts